
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import CustomChipLink from "@/components/CustomChipLink.vue";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import {Getter} from "vuex-class";
import moment from "moment";

@Component({
    components: {
        KeyStatus,
        CustomChipLink,
    },
})
export default class KeyBookedModal extends Vue {

    @Prop({default: null})
    public currentKey: any;

    @Prop({default: false})
    public show: boolean;

    get currentKeyBooking(): string {
        if (!this.currentKey?.currentBooking) {
            return "";
        }
        const startDate = this.currentKey.currentBooking.startDate;
        const endDate = this.currentKey.currentBooking.endDate;
        const parseStartDate = moment(startDate).format("DD-MM-YYYY HH:mm");
        const parseEndDate = moment(endDate).format("DD-MM-YYYY HH:mm");
        return parseStartDate + "  -  " + parseEndDate;
    }

    get currentBooker(): any|undefined {
        return this.currentKey?.currentBooking?.User;
    }

    get route() {
        return {
            name: "planning",
            params: {
                key: this.currentKey,
                user: this.currentBooker,
            },
        };
    }

    private closeModal() {
        this.$emit("closeModal");
    }

}
